/* Omniverse Collectibles — preview interactions.
   Every behaviour here maps to a real Shopify equivalent at port time:
   cart drawer -> /cart/add.js + sections API, reveals -> theme JS, tilt -> section setting. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --o--------- scroll reveals (staggered) --o--------- */
  var revs = document.querySelectorAll('[data-rev]');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = parseFloat(e.target.getAttribute('data-rev')) || 0;
        e.target.style.transitionDelay = d + 'ms';
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revs.forEach(function (el) { io.observe(el); });
  } else {
    revs.forEach(function (el) { el.classList.add('in'); });
  }

  /* --o--------- signature moment: cursor-driven holographic tilt on cards --o--------- */
  if (!reduce && window.matchMedia('(hover:hover)').matches) {
    document.querySelectorAll('.o-card').forEach(function (card) {
      var media = card.querySelector('.o-card__media');
      if (!media) return;
      card.addEventListener('pointermove', function (ev) {
        var r = media.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width;
        var y = (ev.clientY - r.top) / r.height;
        media.style.setProperty('--o-mx', (x * 100).toFixed(1) + '%');
        media.style.setProperty('--o-my', (y * 100).toFixed(1) + '%');
        media.style.transform =
          'perspective(900px) rotateY(' + ((x - 0.5) * 9).toFixed(2) + 'deg) rotateX(' +
          ((0.5 - y) * 9).toFixed(2) + 'deg) translateZ(0)';
      });
      card.addEventListener('pointerleave', function () { media.style.transform = ''; });
    });
  }

  /* --o--------- card flip reveal: hover on mouse, tap on touch, never sticky --o--------- */
  if (!reduce) {
    var hasHover = window.matchMedia('(hover:hover)').matches;
    var flipped = null;
    var flippedAt = 0;

    function unflip() {
      if (flipped) { flipped.classList.remove('o-flip'); flipped = null; }
    }
    function flip(card) {
      if (flipped === card) return;
      unflip();
      card.classList.add('o-flip');
      flipped = card;
      flippedAt = window.scrollY;
    }

    document.querySelectorAll('.o-card').forEach(function (card) {
      var t;
      /* mouse: hover in / out */
      card.addEventListener('pointerenter', function (ev) {
        if (ev.pointerType !== 'mouse') return;
        clearTimeout(t);
        t = setTimeout(function () { flip(card); }, 90);
      });
      card.addEventListener('pointerleave', function (ev) {
        if (ev.pointerType !== 'mouse') return;
        clearTimeout(t);
        if (flipped === card) unflip();
      });

      /* touch / pen: first tap on the artwork flips instead of navigating */
      var imglink = card.querySelector('.o-card__imglink');
      if (imglink) {
        imglink.addEventListener('click', function (ev) {
          if (hasHover && window.matchMedia('(hover:hover)').matches) return;
          if (card.classList.contains('o-flip')) return;
          ev.preventDefault();
          flip(card);
        });
      }
      /* tapping dead space on the back flips it back */
      var back = card.querySelector('.o-card__back');
      if (back) {
        back.addEventListener('click', function (ev) {
          if (ev.target.closest('a, button, form')) return;
          unflip();
        });
      }
    });

    /* three independent escape hatches so a flipped card can never get stuck */
    document.addEventListener('click', function (ev) {
      if (flipped && !flipped.contains(ev.target)) unflip();
    }, true);
    window.addEventListener('scroll', function () {
      if (flipped && Math.abs(window.scrollY - flippedAt) > 260) unflip();
    }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) unflip();
    });

    /* touch devices: replay the flash sweep each time a card scrolls into view */
    if (!window.matchMedia('(hover:hover)').matches && 'IntersectionObserver' in window) {
      var fo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.remove('o-flashin');
            void e.target.offsetWidth;
            e.target.classList.add('o-flashin');
          } else {
            e.target.classList.remove('o-flashin');
          }
        });
      }, { threshold: 0.55 });
      document.querySelectorAll('.o-card').forEach(function (c) { fo.observe(c); });
    }
  }

  /* --o--------- cart drawer (Impulse uses drawer cart — parity kept) --o--------- */
  var scrim = document.querySelector('[data-scrim]');
  var drawer = document.querySelector('[data-drawer]');
  var body = document.querySelector('[data-cart-body]');
  var dotEls = document.querySelectorAll('[data-cart-count]');
  var subEl = document.querySelector('[data-cart-sub]');
  var cart = [];

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function openCart() { if (drawer) { drawer.classList.add('in'); scrim.classList.add('in'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('in'); scrim.classList.remove('in'); } }

  function render() {
    var count = cart.reduce(function (a, i) { return a + i.qty; }, 0);
    var sub = cart.reduce(function (a, i) { return a + i.qty * i.price; }, 0);
    dotEls.forEach(function (d) { d.textContent = count; d.style.display = count ? 'grid' : 'none'; });
    if (subEl) subEl.textContent = money(sub);
    if (!body) return;
    if (!cart.length) { body.innerHTML = '<p class="empty">Your cart is empty.</p>'; return; }
    body.innerHTML = cart.map(function (i) {
      return '<div class="ci"><div class="ci__img"><img src="' + i.img + '" alt=""></div>' +
        '<div><h4>' + i.title + '</h4><span>' + i.qty + ' × ' + money(i.price) + '</span></div></div>';
    }).join('');
  }

  document.addEventListener('click', function (ev) {
    var add = ev.target.closest('[data-add]');
    if (add) {
      ev.preventDefault();
      var title = add.getAttribute('data-title');
      var price = parseFloat(add.getAttribute('data-price'));
      var img = add.getAttribute('data-img');
      var qtyIn = document.querySelector('[data-qty-input]');
      var qty = add.hasAttribute('data-use-qty') && qtyIn ? parseInt(qtyIn.value, 10) || 1 : 1;
      var found = cart.filter(function (i) { return i.title === title; })[0];
      if (found) found.qty += qty; else cart.push({ title: title, price: price, img: img, qty: qty });
      render(); openCart();
      return;
    }
    if (ev.target.closest('[data-open-cart]')) { ev.preventDefault(); openCart(); }
    if (ev.target.closest('[data-close-cart]') || ev.target.hasAttribute('data-scrim')) closeCart();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  render();

  /* --o--------- filter / sort chips (visual state only in preview) --o--------- */
  document.querySelectorAll('[data-chipgroup]').forEach(function (g) {
    g.addEventListener('click', function (ev) {
      var c = ev.target.closest('.o-chip'); if (!c) return;
      ev.preventDefault();
      g.querySelectorAll('.o-chip').forEach(function (x) { x.classList.remove('on'); });
      c.classList.add('on');
    });
  });

  /* --o--------- PDP gallery --o--------- */
  var main = document.querySelector('[data-gal-main]');
  document.querySelectorAll('[data-gal-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('[data-gal-thumb]').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      if (main) main.src = b.querySelector('img').src;
    });
  });

  /* --o--------- PDP variant swatches --o--------- */
  document.querySelectorAll('[data-swgroup]').forEach(function (g) {
    g.addEventListener('click', function (ev) {
      var s = ev.target.closest('.o-sw'); if (!s || s.classList.contains('out')) return;
      g.querySelectorAll('.o-sw').forEach(function (x) { x.classList.remove('on'); });
      s.classList.add('on');
      var p = document.querySelector('[data-price]');
      var btn = document.querySelector('[data-add][data-use-qty]');
      if (p && s.dataset.price) p.textContent = money(parseFloat(s.dataset.price));
      if (btn && s.dataset.price) btn.setAttribute('data-price', s.dataset.price);
    });
  });

  /* --o--------- qty stepper --o--------- */
  var qi = document.querySelector('[data-qty-input]');
  document.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qi) return;
      var v = parseInt(qi.value, 10) || 1;
      v += b.getAttribute('data-qty') === 'up' ? 1 : -1;
      qi.value = Math.max(1, v);
    });
  });

  /* --o--------- sticky buy bar --o--------- */
  var sticky = document.querySelector('[data-sticky]');
  var anchor = document.querySelector('[data-sticky-after]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      sticky.classList.toggle('in', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }
})();
